import OptimizedApp from './components/optimized/OptimizedApp';

function App() {
  return <OptimizedApp />;
}

export default App;